import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { withStorageSync } from '@angular-architects/ngrx-toolkit';

export const PrüfungsTypStore = signalStore(
  { providedIn: 'root' },
  withState({
    _kpruvid: null as number,
  }),
  withComputed(({ _kpruvid }) => ({
    KPRUVID: () => _kpruvid() || 1,
  })),
  withMethods(store => ({
    change(_kpruvid: number) {
      patchState(store, { _kpruvid });
    },
  })),
  withStorageSync('pruefung-typ')
);
